import { axios } from "@/lib/axios";
import { AxiosResponse } from "axios";

export const apiGetAllPendingExchange = (): Promise<
  AxiosResponse<any, any>
> => {
  return axios.get("/chat-s/api/v1/conversations", {
    params: { status: "PENDING" },
  });
};
export const apiGetAllClosedExchange = (): Promise<AxiosResponse<any, any>> => {
  return axios.get("/chat-s/api/v1/conversations", {
    params: { status: "CLOSED" },
  });
};

export const apiAcceptDemand = (
  conversationId: string
): Promise<AxiosResponse<any, any>> => {
  return axios.patch(
    "/chat-s/api/v1/conversations/" + conversationId + "/validate",
    {
      validation: "ACCEPTED",
      // rejectedReason: ""
    }
  );
};

export const apiRejectDemand = (
  conversationId: string,
  motif: string
): Promise<AxiosResponse<any, any>> => {
  return axios.patch(
    "/chat-s/api/v1/conversations/" + conversationId + "/validate",
    {
      validation: "REJECTED",
      rejectedReason: motif,
    }
  );
};

export const apiCancelDemand = (
  conversationId: string
): Promise<AxiosResponse<any, any>> => {
  return axios.patch(
    "/chat-s/api/v1/conversations/" + conversationId + "/cancel"
  );
};

export const apiEndUpExchange = (
  conversationId: string,
  note: string
): Promise<AxiosResponse<any, any>> => {
  return axios.patch(
    "/chat-s/api/v1/conversations/" + conversationId + "/close",
    {
      closeReason: note,
    }
  );
};

export const apiRemindDemand = (
  receiverProfileId: string
): Promise<AxiosResponse<any, any>> => {
  return axios.post(
    "/chat-s/api/v1/conversations/" + receiverProfileId + "/relaunch"
  );
};

export const apiSendMessage = (
  message: string,
  conversationId: string
): Promise<AxiosResponse<any, any>> => {
  return axios.post(
    "/chat-s/api/v1/conversations/" + conversationId + "/messages",
    { message }
  );
};

export const apiGetConversation = (
  page: number = 1,
  limit: number = 100,
  conversationId: string
): Promise<AxiosResponse<any, any>> => {
  return axios.get(
    "/chat-s/api/v1/conversations/" +
      conversationId +
      "/messages?page=" +
      page +
      "&limit=" +
      limit
  );
};

export const apiGetConversationCursor = (
  cursor: string,
  limit: number = 20,
  conversationId: string
): Promise<AxiosResponse<any, any>> => {
  const params = new URLSearchParams();
  if (cursor) {
    params.append("cursor", cursor);
  }
  params.append("limit", limit.toString());

  return axios.get(
    `/chat-s/api/v1/conversations/${conversationId}/messages/cursor`,
    {
      params: {
        cursor,
        limit,
      },
    }
  );
};

export const markMessageAsRead = (
  conversationId: string,
  messageIdArray: string[],
  receiverId: string
): Promise<AxiosResponse<any, any>> => {
  return axios.patch(
    "/chat-s/api/v1/conversations/" + conversationId + "/messages/mark-as-read",
    { messageIds: messageIdArray, receiverId }
  );
};

export const relaunch = (
  receiverProfileId: string
): Promise<AxiosResponse<any, any>> => {
  return axios.post(
    "/chat-s/api/v1/conversations/current/" + receiverProfileId + "/relaunch"
  );
};
